import Edit from '../../../assets/icons/Edit';
import { IReassigmentProvider } from '../../../interfaces/service/ReassignmentServiceManagerInterface';
import { DeviceForm } from './forms/deviceForm';
import { SamForm } from './forms/samForm';

interface IServiceMenuComponent {
  serviceReassignment: IReassigmentProvider;
}

export const RightMenu = (props: IServiceMenuComponent) => {
  const { serviceReassignment } = props;

  const titleMenu = () => {
    return (
      <div className="flex w-full h-full flex-col content-center justify-center items-center rounded-l-lg ">
        <div className="flex flex-row w-full h-[60%] content-center justify-start items-center">
          <div className="flex ml-10">
            <Edit className="text-official_green"/>
            <p className="ml-2 place-self-center font-bold text-xl">
              Reasignar {serviceReassignment.radioSelection === 'SAM' ? 'SAM' : 'Equipo'}
            </p>
          </div>
        </div>
        <div className="flex flex-row w-full h-[10%] bg-official_green"></div>
      </div>
    );
  };

  return (
    <div className="flex w-full h-full flex-col items-center bg-white shadow-[-6px_-1px_5px_#00000024] z-10 right-0">
      <div className="flex w-full h-[10%] ">{titleMenu()}</div>
      <div className="flex w-full h-[85%]">
        <div className="w-full">
          {
          serviceReassignment.radioSelection === 'SAM'? 
          <SamForm serviceReassignment={serviceReassignment}/>
          : 
          <DeviceForm serviceReassignment={serviceReassignment}/>
          }
          </div>
        </div>
    </div>
  );
};
